import useWakeLock from '../../utils/useWakeLock';
var WakeLock = function () {
    // Use the wake lock hook - it will handle mobile detection internally
    useWakeLock();
    // This component doesn't render anything visible
    // It just manages wake lock functionality
    return null;
};
export default WakeLock;
